import { getSession } from "next-auth/react";

import AuthWrapper from "@/components/sections/auth/wrapper";

function SignIn() {
  return (
    <div className="container my-[3rem] xl:my-[5rem]">
      <div className="mx-auto max-w-[80rem]">
        <AuthWrapper />
      </div>
    </div>
  );
}

export const getServerSideProps = async ({ req }) => {
  const session = await getSession({ req });

  if (session?.user?.token) {
    return {
      redirect: {
        destination: "/",
        permanent: false,
      },
    };
  }

  return {
    props: { session },
  };
};

export default SignIn;
